import { apiConfig } from '@/services/api-config';

export default async function (frigId: string) {
  const userLogged = sessionStorage.getItem('userLogged');

  let stKey = '';

  if (userLogged) stKey = JSON.parse(userLogged).company.stKey;

  return apiConfig
    .get(`api/territory/get-by-frig-id?frigId=${frigId}&tokenKey=${stKey}`)
    .then((response) => {
      const { objectResult } = response.data;

      return objectResult;
    })
    .catch(() => []);
}
